import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'

import { Box, Button, Dropzone, Header2, Icon, Text } from '~design-system'
import { documentMimeTypes } from '~helpers'
import { useUser } from '~hooks'

import { UploadPopinProps } from '..'

const ProofOfIdentity = ({ onClose, option, onSubmit }: UploadPopinProps) => {
  const {
    control,
    register,
    reset,
    getValues,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm({
    mode: 'onChange',
  })
  const { useUploadDocument } = useUser()
  const { mutateAsync: uploadDoc } = useUploadDocument()
  const [process, setProcess] = useState<'Recto' | 'Verso'>('Recto')

  const isIdentityCard = option.identity_document === "Carte d'identité"

  const onUpload = async () => {
    try {
      await uploadDoc(getValues())
      if (isIdentityCard && process === 'Recto') {
        setProcess('Verso')
        reset()
      } else {
        onSubmit([
          `${option.identity_document} envoyé${isIdentityCard ? 'e' : ''}`,
        ])
        onClose()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <Header2 mb={4}>Vérifie ton identité</Header2>
      <Text mb={8} textColor="greyDarkest">
        Nous avons besoin de vérifier ton identé pour t’indiquer si tu es
        éligible. 🗂
      </Text>
      <form onSubmit={handleSubmit(onUpload)}>
        <Box di="f" jc="space-between">
          <Text>
            {option.identity_document} {isIdentityCard && `- ${process}`}
            <sup>*</sup>
          </Text>
        </Box>
        <Text textColor="greyDarkest">
          Importe {isIdentityCard && 'le recto et le verso de'} ton document
          d’identité ici en t’assurant qu’il soit facilement lisible 🤓
        </Text>
        <input
          id="identity_document"
          type="hidden"
          {...register('identity_document', {
            value: option.identity_document,
          })}
        />
        <Controller
          control={control}
          name="proof_of_identity"
          rules={{ required: true }}
          render={({ field: { onChange, value } }) => (
            <Dropzone
              multiple={false}
              accept={documentMimeTypes}
              file={value && [value]}
              setFile={(val?: string[] | null[]) =>
                onChange(val ? val[0] : undefined)
              }
            >
              <Box di="f" fd="column" ai="center" js="center">
                <Icon name="camera" color="primary" />
                <Text textColor="primary">
                  Importe{' '}
                  {isIdentityCard && `le ${process.toLowerCase()} de ton`}{' '}
                  document d'identité
                </Text>
              </Box>
            </Dropzone>
          )}
        />
        <Box>
          <Box di="f" mt={6}>
            <Button
              type="submit"
              data-testid="identity-submit"
              disabled={!isValid || isSubmitting}
              isLoading={isSubmitting}
            >
              {process === 'Recto' && isIdentityCard ? 'Suivant' : 'Valider'}
            </Button>
            <Text as="button" color="greyDarkest" onClick={onClose}>
              Compléter plus tard
            </Text>
          </Box>
        </Box>
      </form>
    </>
  )
}

export default ProofOfIdentity
